import {useCallback, useEffect, useState} from "react";
import {ApplicationService} from "../../service/ApplicationService";

export const useThemeSelector = (force?: boolean) => {

    const [theme, setTheme] = useState("default");
    const [themeSet, setThemeSet] = useState(false)

    const getTheme = useCallback(async () => {
        setThemeSet(false)
        if (force) {
            localStorage.removeItem("theme")
        }
        const verificationId =  window.location.pathname.split("/")[1]
        let key = localStorage.getItem("theme")
        if (verificationId) {
            if (!key) {
                key = await ApplicationService.getInstance().getTheme(verificationId)
                localStorage.setItem('theme', key)
            }
            setTheme(key)
            setThemeSet(true)
        }
    }, [force])

    useEffect(() => {
        getTheme()
    }, [getTheme])

    return {
        theme,
        themeSet
    }

}